import { createApp, h } from 'vue';
import i18n from './vue-deliveryaddress-i18n';
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import { EventTypes } from './delivery-address-events';
import NewDeliveryAddress from './components/new-delivery-address';

PubSub.subscribe(EventTypes.TEXTS_LOADED, () => {
    let vueNewDeliveryAddressApp = null
    PubSub.subscribe(EventTypes.SHOW_CREATE_NEW_ADDRESS, () => {
        vueNewDeliveryAddressApp = createApp({
            components: { 'new-delivery-address': NewDeliveryAddress },
            render: () => h(NewDeliveryAddress),
        });
        vueNewDeliveryAddressApp.use(i18n, {});
        vueNewDeliveryAddressApp.use(ToastPlugin, {
            duration: 5000,
            position: 'bottom-right'
        });
        
        vueNewDeliveryAddressApp.mount("#vue-modal-plch");
    });

    PubSub.subscribe(EventTypes.UNMOUNT_NEW_DELIVERY_ADDRESS_APP, () => {
        vueNewDeliveryAddressApp.unmount();
    });

});